import { Controller } from "@hotwired/stimulus"
import { refreshPhone } from "../studio_phone"

// spots.by's studio lists (29 Oct 2026): drag a row by its grip, up or down,
// then the new order is saved at once and the phone beside reloads. Pointer
// events, so a finger drags as well as a mouse. The order is posted as JSON
// under the key the list names ("ids", or "design.social_order"), and the
// answer carries the page's new version, as studio_controller.js expects.
export default class extends Controller {
  static targets = ["item"]
  static values = { url: String, key: { type: String, default: "ids" } }

  grab(event) {
    if (event.button > 0) return
    const item = event.target.closest("[data-sort-target=item]")
    if (!item) return
    event.preventDefault()
    this.item = item
    this.startY = event.clientY
    this.before = this.order()
    item.classList.add("dragging")
    document.documentElement.classList.add("st-sorting")
    this.onMove = (e) => this.move(e)
    this.onDrop = () => this.drop()
    window.addEventListener("pointermove", this.onMove)
    window.addEventListener("pointerup", this.onDrop, { once: true })
    window.addEventListener("pointercancel", this.onDrop, { once: true })
  }

  move(event) {
    const item = this.item
    let dy = event.clientY - this.startY
    const prev = this.sibling(item, "previousElementSibling")
    const next = this.sibling(item, "nextElementSibling")
    if (prev && dy < -prev.offsetHeight / 2) {
      item.parentNode.insertBefore(item, prev)
      this.startY -= prev.offsetHeight
    } else if (next && dy > next.offsetHeight / 2) {
      item.parentNode.insertBefore(next, item)
      this.startY += next.offsetHeight
    }
    dy = event.clientY - this.startY
    item.style.transform = `translateY(${dy}px)`
  }

  drop() {
    window.removeEventListener("pointermove", this.onMove)
    window.removeEventListener("pointerup", this.onDrop)
    window.removeEventListener("pointercancel", this.onDrop)
    document.documentElement.classList.remove("st-sorting")
    if (!this.item) return
    this.item.classList.remove("dragging")
    this.item.style.transform = ""
    this.item = null
    const order = this.order()
    if (order.join() !== this.before.join()) this.save(order)
  }

  sibling(item, direction) {
    let el = item[direction]
    while (el && el.dataset.sortTarget !== "item") el = el[direction]
    return el
  }

  order() { return this.itemTargets.map((el) => el.dataset.id) }

  save(order) {
    const body = this.keyValue.split(".").reverse().reduce((value, key) => ({ [key]: value }), order)
    const token = document.querySelector("meta[name=csrf-token]")?.content
    fetch(this.urlValue, {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: { "X-CSRF-Token": token, "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin"
    }).then((response) => {
      if (!response.ok) throw new Error(response.status)
      return response.json()
    }).then(({ version }) => refreshPhone(version)).catch(() => window.location.reload())
  }
}
